export const SET_CURRENT_LANG = "SET_CURRENT_LANG";
